import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { InsuranceService } from 'src/app/services/insurance.service';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-insurance-commercials',
  templateUrl: './insurance-commercials.component.html',
  styleUrls: ['./insurance-commercials.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class InsuranceCommercialsComponent {
  columnsDisplay: string[] = ['source','bookingType','serviceChargeFix'];
  expandedElement!: any | null;
  dataSource:any=[]
  insuranceRegFg!:FormGroup
  pageStr:any={
    number:'0',
    size:'10'
  }
  commercialData:any
constructor(private InsuranceService:InsuranceService,private toastMsgService : ToastmsgService,private fb:FormBuilder,private DataService:DataService){
  this.DataService.portMessage.subscribe((message:any) => this.commercialData = message)
if(this.commercialData.id){
  this.dataFields()
  this.getList()
}
}

showPopup:boolean=false
disable:boolean=false
  AddCommercials() {
    this.disable=true
    this.InsuranceService.saveCommercial(this.insuranceRegFg.value)
      .subscribe({
        next : (res) => {
          this.disable=false

          if(res.status==200 || res.status==201) {
            this.toastMsgService.setMsg({msg : "Commercial Added Successfully!",msgTitle : "Success", msgType : "I"});
           // this.router.navigate(["/sign-in"]);
           this.showPopup=false
           this.getList()
           this.dataFields()
          } else {
            const body : any = res.body;
            this.registerErrorMsg(res.status,body?.result);
          } 

        },error : (err) => {
          this.disable=false

          this.registerErrorMsg(err.status,err.error);
        }
      }
    )
  }

  registerErrorMsg(status : number,msg : string) {
    if(status >=500) {
      this.toastMsgService.setMsg({msg : "Failed to save Commercial",msgTitle : "Warning", msgType : "W"});
    } else {

      this.toastMsgService.setMsg({msg : "Failed to save Commercial",msgTitle:  "Warning", msgType : "W"});
    } 
  }
  action:any
  dataFields(){

  
    this.insuranceRegFg=this.fb.group({
      "userUuid" :  [this.commercialData.id,[Validators.required]],
      "bookingType" :  ['',[Validators.required]],
      "source" : ['',[Validators.required]],
      "serviceChargeFix":['',[Validators.required]]
  });
  
   
    
  }

  getList(){
    this.InsuranceService.commercialList(this.commercialData.id)
    .subscribe({
      next : (res) => {
        if(res) {
          let data:any=res
          this.dataSource=data?.body?.result
         console.log(res)
        } else {
        } 

      },error : (err) => {

      }
    }
  )
  }
  onClickPopup(){
    this.action='new'
    this.DataService.portMessage.subscribe((message:any) => this.commercialData = message)
    this.showPopup=true
    this.dataFields()
  }
  updateId:any
  rowClick(item:any){
    this.updateId=item?.id
    this.action='update'
    this.insuranceRegFg=this.fb.group({
      "userUuid" :  [item?.userUuid,[Validators.required]],
      "bookingType" :  [item?.bookingType,[Validators.required]],
      "source" : [item?.source,[Validators.required]],
      "serviceChargeFix":[item?.serviceChargeFix,[Validators.required]]
  });
  this.showPopup=true

  }
  closePopup(){
    this.showPopup=false

    

  }


  UpdateCommercials() {
    this.disable=true

    this.InsuranceService.updateCommercial(this.insuranceRegFg.value,this.updateId)
      .subscribe({
        next : (res) => {
          this.disable=false

          if(res.status==200 || res.status==201) {
            this.toastMsgService.setMsg({msg : "Commercial Updated Successfully!",msgTitle : "Success", msgType : "I"});
           // this.router.navigate(["/sign-in"]);
           this.showPopup=false
           this.getList()
           this.dataFields()
          } else {
            const body : any = res.body;
            this.registerUpateErrorMsg(res.status,body?.result);
          } 

        },error : (err) => {
          this.disable=false

          this.registerUpateErrorMsg(err.status,err.error);
        }
      }
    )
  }

  registerUpateErrorMsg(status : number,msg : string) {
    if(status >=500) {
      this.toastMsgService.setMsg({msg : "Failed to Update Commercial",msgTitle : "Warning", msgType : "W"});
    } else {

      this.toastMsgService.setMsg({msg : "Failed to Update Commercial",msgTitle:  "Warning", msgType : "W"});
    } 
  }

  onlyNumberKey(event:any) {
     
    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
        && (charCode < 48 || charCode > 57))
        return false;
    return true;
  }
}
